<!--账号配置Ec-->
<template>
  <div class="account-setting">
    <div class="step">
      <h6>第一步：配置账号</h6>
      <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
        <el-form-item label="application_id" prop="param1" :rules="{ required: true, message: '请输入application_id', trigger: 'change' }">
          <el-input placeholder="请输入application_id" v-model="formAccount.param1"></el-input>
        </el-form-item>
        <el-form-item label="application_secret" prop="param2" :rules="{ required: true, message: '请输入application_secret', trigger: 'change' }">
          <el-input placeholder="请输入application_secret" v-model="formAccount.param2"></el-input>
        </el-form-item>
        <el-form-item label="人员表格的id" prop="param3" :rules="{ required: true, message: '请输入人员表格的id', trigger: 'change' }">
          <el-input placeholder="请输入人员表格的id" v-model="formAccount.param3"></el-input>
        </el-form-item>
        <el-form-item label="资源表格的id" prop="param4" :rules="{ required: true, message: '请输入资源表格的id', trigger: 'change' }">
          <el-input placeholder="请输入资源表格的id" v-model="formAccount.param4"></el-input>
        </el-form-item>
        <el-form-item label="资源所有者字段名称" prop="param5" :rules="{ required: true, message: '请输入资源所有者字段名称', trigger: 'change' }">
          <el-input placeholder="请输入资源所有者字段名称" v-model="formAccount.param5"></el-input>
        </el-form-item>
        <el-form-item label="客人来源字段名称" prop="param6">
          <el-input placeholder="请输入客人来源字段名称" v-model="formAccount.param6"></el-input>
        </el-form-item>
        <el-form-item label="标签字段名称" prop="param7">
          <el-input placeholder="请输入标签字段名称" v-model="formAccount.param7"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="step">
      <h6>第二步：信息配置</h6>
      <p class="goSetting">来源配置、字段配置</p>
    </div>
    <div class="step">
      <h6>第三步：配置话务排班</h6>
      <p class="goSetting"><span>*</span>去资源同步crm-伙伴云-话务排班-日期配置</p>
    </div>
    <div class="step">
      <h6>第四步：打开同步开关</h6>
      <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
        <el-form-item label="同步数据到伙伴云" prop="sync">
          <el-switch v-model="formAccount.sync"></el-switch>
        </el-form-item>
        <!-- <p class="tip"><i class="el-icon-warning-outline"></i>资源同步crm只支持招商智投(智投)模式</p> -->
        <div class="button">
          <el-button type="primary" size="small" @click="submitForm('formAccount')">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import {FormArgument} from '@/models/ec-setting'
  import Api from '@/api/client/ec-setting'
  export default {
    data () {
      return {
        name: 'huoban',
        formAccount: new FormArgument()
      }
    },
    created () {
      this.getAccount()
    },
    methods: {
      getAccount () {
        const crmCode = {
          crmCode: this.name
        }
        Api.getEcAccount(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.formAccount = body
          } else {
            this.table.list = []
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        this.$confirm('确定保存？若配置账号修改变化了，之前的配置数据将被清除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formAccount.crmCode = this.name
          this.$refs[formName].validate((valid) => {
            if (valid) {
              Api.addEcAccount(this.formAccount, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status === 200 || status === 204) {
                  this.$message.success('保存成功！')
                } else {
                  this.$message.error(body.error || '保存失败')
                }
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    }
  }
</script>
<style scoped lang="scss">
.account-setting{
  margin-top:15px;
  h6{
    color:#1F2F3D;
    font-size: 22px;
    font-weight: normal;
    line-height: 3;
    margin:0;
  }
  .goSetting{
    color:#606266;
    font-size: 14px;
    margin:0 0 20px;
    span{
      color:#FF0000;
      padding-right:5px;
    }
  }
  .tip{
    color:#FF4F4F;
    font-size: 12px;
    position: relative;
    top:-10px;
    i{
      margin-right:5px;
      font-size: 14px;
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    button{
      width:100px;
      height:30px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding:0;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/hby/hbyAccount.vue